import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CartService {
  private openCart = new Subject<boolean>()
  openCartMenu$ = this.openCart.asObservable()
  constructor() {}

  openCartMenu(val) {
    this.openCart.next(!val)
  }
}
